import { render, staticRenderFns } from "./NetBenefitsHeader.vue?vue&type=template&id=2dc76df8&scoped=true"
import script from "./NetBenefitsHeader.vue?vue&type=script&lang=js"
export * from "./NetBenefitsHeader.vue?vue&type=script&lang=js"
import style0 from "./NetBenefitsHeader.vue?vue&type=style&index=0&id=2dc76df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc76df8",
  null
  
)

export default component.exports